export class BaseEvent {
    public id: string;
    public name: string;
    public timeZone: string;
    public startDateTime: Date;
    public endDateTime: Date;
    public approvalStatus: string;
}
